<template>
<div>
    <Breadcrumbs main="Admin" submain="Subscription" title="User Analytics" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card"> 
                    <div class="card-body">
                        <b-row class="mb-4 d-flex justify-content-between">
                            <b-col lg="6" class="d-flex flex-wrap" style="gap: 20px">
                                <b-input-group style="width: 340px;">
                                    <b-form-input v-model="user_name" @keyup="searchUsers" placeholder="Type to Search"></b-form-input>
                                    <b-input-group-append>
                                        <b-button @click="clearSearch">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>
                            <b-col lg="6" class="d-flex flex-wrap justify-content-end align-items-center" style="gap: 10px; margin-top: 8px;">
                                <span>Count: </span> <b-badge variant="primary" style="font-size: 16px; max-width: fit-content;">{{ totalRows }}</b-badge>
                            </b-col>
                        </b-row>
                        <div style="display: flex; flex-wrap: wrap; gap: 8px;">
                            <div class="grid-container mt-sm-0">
                                <div class="grid-item">
                                    <span>Date From</span>
                                    <div class="form-group">
                                        <input type="date" class="form-control" v-model="date_from" style="width: 200px;">
                                    </div>
                                </div>
                            </div>
                            <div class="grid-container mt-sm-0">
                                <div class="grid-item">
                                    <span>Date To</span>
                                    <div class="form-group">
                                        <input type="date" class="form-control" v-model="date_to" style="width: 200px;">
                                    </div>
                                </div>
                            </div>
                            <div class="grid-container mt-sm-0">
                                <div class="grid-item">
                                    <span>Minimum Coin</span>
                                    <div class="form-group">
                                        <b-form-input type="number" v-model="minimum_coin" placeholder="Type minimum coin" style="width: 200px;"></b-form-input>
                                    </div>
                                </div>
                            </div>
                            <div class="grid-container mt-sm-0">
                                <div class="grid-item">
                                    <span>Maximum Coin</span>
                                    <div class="form-group">
                                        <b-form-input type="number" v-model="maximum_coin" placeholder="Type maximum coin" style="width: 200px;"></b-form-input>
                                    </div>
                                </div>
                            </div>
                            <div class="grid-container mt-sm-0">
                                <div class="grid-item">
                                    <span>Minimum Profile Completion</span>
                                    <div class="form-group">
                                        <b-form-input type="number" v-model="minimum_completion" placeholder="Type minimum percentage" style="width: 200px;"></b-form-input>
                                    </div>
                                </div>
                            </div>
                            <div class="grid-container mt-sm-0">
                                <div class="grid-item">
                                    <span>Maximum Profile Completion</span>
                                    <div class="form-group">
                                        <b-form-input type="number" v-model="maximum_completion" placeholder="Type maximum percentage" style="width: 200px;"></b-form-input>
                                    </div>
                                </div>
                            </div>
                            <div style="margin-top: 20px; display: flex; align-items: center; text-align: center; justify-content: center; color: white; background-color: #262062; padding: 2px 14px; width: 100px; border-radius: 5px; cursor: pointer; height: 39px;" @click="filterUserList()">
                                <h7>Filter</h7>
                            </div>
                            <div v-if="filterShow" style="margin-top: 20px; display: flex; align-items: center; text-align: center; justify-content: center; color: white; background-color: #DC3545; padding: 2px 14px; width: 100px; border-radius: 5px; cursor: pointer; height: 39px;" @click="resetFilters()">
                                <h7>Reset</h7>
                            </div>
                        </div>

                        <div v-if="!loading && !error && !loadingPage">
                            <div class="table-responsive datatable-vue mt-3">
                                <b-table :items="subscriber_list" :fields="tablefields" :per-page="perPage" :filter="filter" show-empty stacked="md">

                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(user_object)="row">
                                        <div style="display: flex; flex-direction: column; gap: 4px;">
                                            <h7>{{ row.item.user_object?.first_name }} {{ row.item.user_object?.last_name }}</h7>
                                            <b-badge style="font-size: 13px; max-width: fit-content;">{{ row.item.user_object?.email }}</b-badge>
                                        </div>
                                    </template>

                                    <template #cell(profile_id)="row">
                                        <h7>{{ row.item.personal_info?.profile_id }}</h7>
                                    </template>

                                    <template #cell(phone_no)="row">
                                        <h7>{{ row.item.personal_info?.phone_number }}</h7>
                                    </template>

                                    <template #cell(completion)="row">
                                        <h7>{{ row.item?.completion }}%</h7>
                                    </template>

                                    <template #cell(personal_info.first_registration_date)="row">
                                        <h7 v-if="row.item.personal_info">{{ formatDate(row.item.personal_info?.first_registration_date).date }} <br> {{ formatDate(row.item.personal_info?.first_registration_date).time }}</h7>
                                    </template>

                                    <template #cell(wallet_balance)="row">
                                        <router-link :to="{ path: '/subscription/user/wallet', query: { user_id: row.item.user_object?.id } }">
                                            <b-badge variant="primary" style="font-size: small;">{{ row.item.personal_info?.wallet_balance }}</b-badge>
                                            <p style="padding-top: 8px; font-weight: 600; border-bottom: 2px solid #262062; width: 54px;">History</p>
                                        </router-link>
                                    </template>

                                    <template #cell(action)="data">
                                        <div style="display: flex; gap: 8px; align-items: center;">
                                            <!-- <input style="width: 16px; height: 16px; cursor: pointer;" type="checkbox" id="flexSwitchCheck" v-model="data.item.personal_info.test_property" @change="handleToggle(data.item.personal_info?.user)" v-b-tooltip.hover title="Toggle Test Profile" /> -->
                                            <router-link :to="{ path: '/subscription/user/activity-log', query: { user_id: data.item?.user_object?.id } }">
                                                <feather type="eye" size="21px" style="color: #262261; cursor: pointer; margin-top: 6px;" v-b-tooltip.hover title="Activity Log"></feather>
                                            </router-link>
                                            <feather type="delete" size="20px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteUser(data.item?.user_object?.id)" title="Delete"></feather>
                                        </div>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-row class="mt-3">
                            <b-col xl="12" class="d-flex flex-wrap justify-content-between align-items-center" style="gap: 28px;">
                                <span style="display: flex; gap: 4px; min-width: fit-content;">
                                    <span>
                                        <!-- First Page Button (<<) -->
                                        <button class="pg-button" :disabled="currentPage === 1" @click="goToPage(1)">
                                            <b-icon icon="chevron-double-left"></b-icon>
                                        </button>
        
                                        <!-- Previous Page Button (<) -->
        
                                        <button class="pg-button ml-2" :disabled="currentPage === 1" @click="goToPage(currentPage - 1)">
                                            <b-icon icon="chevron-left"></b-icon>
                                        </button>
                                    </span>

                                    <!-- Page Number Display (Page X of Y) -->
                                    <span class="align-self-center">
                                        <span class="align-self-center">
                                            <span class="d-flex align-items-center" style="gap: 6px; padding: 0px 8px;">
                                                <span>Page</span>
                                                <b-form-input v-model="currentPage" style="box-shadow: none; width: 54px; text-align: center;" @blur="validatePage" @keydown.enter="validatePage" :disabled="totalPages <= 1"></b-form-input>
                                                <span>of {{ totalPages }}</span>
                                            </span>
                                        </span>
                                    </span>

                                    <span>
                                        <!-- Next Page Button (>) -->
                                        <button class="mr-2 pg-button" :disabled="currentPage === totalPages" @click="goToPage(currentPage + 1)">
                                            <b-icon icon="chevron-right"></b-icon>
                                        </button>
        
                                        <!-- Last Page Button (>>) -->
                                        <button class="pg-button" :disabled="currentPage === totalPages" @click="goToPage(totalPages)">
                                            <b-icon icon="chevron-double-right"></b-icon>
                                        </button>
                                    </span>
                                </span>

                                <div style="min-width: 200px; display: flex; align-items: center;">
                                    <span style="width: 160px;">Per page:</span> <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- User Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this user?</div>
    </b-modal>
</div>
</template>

<script>
import { mapState } from 'vuex';
import { myHost } from '../../../_helpers/host';
import loader from '../loader/loader.vue';
import Multiselect from 'vue-multiselect';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    components: {
        loader,
        Multiselect
    },

    data() {
        return {
            host: myHost.host,
            selected: [],
            isDisabled: false,
            subscriber: {

            },
            tablefields: [
                {
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'user_object',
                    label: 'Subscriber',
                    sortable: false
                },
                {
                    key: 'phone_no',
                    label: 'Phone No',
                    sortable: false
                },
                {
                    key: 'profile_id',
                    label: 'Profile ID',
                    sortable: false
                },
                {
                    key: 'personal_info.first_registration_date',
                    label: 'Registered On',
                    sortable: true
                },
                {
                    key: 'completion',
                    label: 'Profile Completion',
                    sortable: false
                },
                {
                    key: 'wallet_balance',
                    label: 'Balance (Coin)',
                    sortable: false
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],
            delete_value: null,
            initialLoad: true,
            filterShow: false,
            user_name: null,
            date_from: null,
            date_to: null,
            minimum_coin: null,
            maximum_coin: null,
            minimum_completion: null,
            maximum_completion: null,
            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 25,
            loadingPage: false,
            pageOptions: [25, 50, 100]
        };
    },

    computed: {
        ...mapState({
            subscription_types: state => state.packages.package,
            subscriber_list: state => state.subscriber.subscriber,
            loading: state => state.subscriber.subscriberLoading,
            error: state => state.subscriber.subscriberError,
            count: state => state.subscriber.subscriber_count
        }),

        formattedSubscription() {
            return [{
                    value: null,
                    text: 'Select a subscription type',
                    disabled: true
                },
                ...this.subscription_types.map(type => ({
                    value: type.id,
                    text: type.title + " (" + type.type + ")"
                }))
            ];
        },

        totalPages() {
            if (typeof this.totalRows === 'number' && !isNaN(this.totalRows) && this.totalRows > 0) {
                return Math.ceil(this.totalRows / this.perPage);
            }
            return 1; // Default to 1 if totalRows is invalid
        }
    },

    watch: {
        currentPage(newCurrentPage) {
            if (!this.initialLoad) {
                if (this.currentPage === null || this.currentPage === '') {
                    this.loadingPage = true
                }

                this.$router.replace({
                    path: '/subscription/user/analytics',
                    query: {
                        page: newCurrentPage,
                        perPage: this.perPage
                    }
                });
                
                this.currentPage = newCurrentPage
                this.$store.dispatch("subscriber/fetchSubscriber", {
                    perPage: this.perPage,
                    currentPage: newCurrentPage,
                    user_name: this.user_name,
                    minimum_coin: this.minimum_coin,
                    maximum_coin: this.maximum_coin,
                    minimum_completion: this.minimum_completion,
                    maximum_completion: this.maximum_completion,
                    date_from: this.date_from,
                    date_to: this.date_to
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false
                });
            }
        },

        perPage(newperPage) {
            if (!this.initialLoad) {

               this.$router.replace({
                    path: '/subscription/user/analytics',
                    query: {
                        page: newCurrentPage,
                        perPage: this.perPage
                    }
                });

                this.perPage = newperPage
                this.$store.dispatch("subscriber/fetchSubscriber", {
                    perPage: newperPage,
                    currentPage: this.currentPage,
                    user_name: this.user_name,
                    minimum_coin: this.minimum_coin,
                    maximum_coin: this.maximum_coin,
                    minimum_completion: this.minimum_completion,
                    maximum_completion: this.maximum_completion,
                    date_from: this.date_from,
                    date_to: this.date_to
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false
                });
            }
        }
    },

    created() {
        this.$store.dispatch("packages/fetchPackage")
    },

    mounted() {
        if (this.initialLoad) {
            if (!this.$route.query.page || !this.$route.query.perPage) {
                this.$router.replace({
                    path: this.$route.path,
                    query: {
                        page: this.currentPage,
                        perPage: this.perPage
                    }
                }).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        throw err;
                    }
                });
                this.fetchInitial();
            } else {
                this.currentPage = parseInt(this.$route.query.page);
                this.perPage = parseInt(this.$route.query.perPage);
                this.fetchInitial();
            }
        }
    },

    methods: {
        validatePage() {
            this.loadingPage = true;
            const totalPages = this.totalPages;
            
            if (!this.currentPage || isNaN(this.currentPage) || this.currentPage < 1) {
                this.currentPage = 1;
            } else if (Number(this.currentPage) > totalPages) {
                this.currentPage = totalPages; // Set to last valid page
            }

            this.loadingPage = false;
        },

        goToPage(page) {
            if (page < 1 || page > this.totalPages) return;
            this.currentPage = page;
        },

        formatDate(dateStr) {
            if (!dateStr) return ''

            const date = new Date(dateStr)

            const day = date.getDate()
            const month = date.toLocaleString('default', {
                month: 'long'
            })
            const year = date.getFullYear()

            const hours = date.getHours()
            const minutes = date.getMinutes().toString().padStart(2, '0')
            const ampm = hours >= 12 ? 'PM' : 'AM'
            const hour12 = hours % 12 || 12

            const getOrdinal = (n) => {
                const s = ['th', 'st', 'nd', 'rd']
                const v = n % 100
                return s[(v - 20) % 10] || s[v] || s[0]
            }

            return {
                date: `${day}${getOrdinal(day)} ${month}, ${year}`,
                time: `${hour12}:${minutes} ${ampm}`
            }
        },

        fetchInitial() {
            this.$store.dispatch("subscriber/fetchSubscriber", {
                perPage: this.$route.query.perPage,
                currentPage: this.$route.query.page,
                user_name: this.user_name,
                minimum_coin: this.minimum_coin,
                maximum_coin: this.maximum_coin,
                minimum_completion: this.minimum_completion,
                maximum_completion: this.maximum_completion,
                date_from: this.date_from,
                date_to: this.date_to
            }).then(() => {
                this.totalRows = this.count;
                this.initialLoad = false;
            });
        },

        deleteUser(id) {
            this.delete_value = id
        },

        handleDeleteOk() {
            this.$store.dispatch("subscriber/deleteSubscriber", {
                delete: this.delete_value,
                perPage: this.$route.query.perPage,
                currentPage: this.$route.query.page
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.message,
                        icon: "success"
                    });
                    this.delete_value = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },

        handleToggle(user_id) {
            this.$store.dispatch("subscriber/toggleTestProfile", {
                user_id: user_id,
                perPage: this.$route.query.perPage,
                currentPage: this.$route.query.page
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.message,
                        icon: "success"
                    });
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },

        resetFilters() {
            this.filterShow = false;
            this.user_name = null;
            this.date_from = null;
            this.date_to = null;
            this.minimum_coin = null;
            this.maximum_coin = null;
            this.minimum_completion = null;
            this.maximum_completion = null;
            this.$router.replace({
                path: '/subscription/user/analytics',
                query: {
                    page: this.currentPage,
                    perPage: this.perPage
                }
            });
            this.fetchInitial();
        },

        filterUserList() {
            this.filterShow = true;
            this.$store.dispatch("subscriber/fetchSubscriber", {
                perPage: this.perPage,
                currentPage: this.currentPage,
                user_name: this.user_name,
                minimum_coin: this.minimum_coin,
                maximum_coin: this.maximum_coin,
                minimum_completion: this.minimum_completion,
                maximum_completion: this.maximum_completion,
                date_from: this.date_from,
                date_to: this.date_to,
            }).then(() => {
                this.totalRows = this.count;
                this.currentPage = 1;
            });
        },

        searchUsers() {
            if (this.user_name && this.user_name.trim() !== '' && this.user_name.length >= 2) {
                this.$store.dispatch("subscriber/fetchSubscriber", {
                    user_name: this.user_name,
                    perPage: this.$route.query.perPage,
                    currentPage: this.$route.query.page,
                    minimum_coin: this.minimum_coin,
                    maximum_coin: this.maximum_coin,
                    minimum_completion: this.minimum_completion,
                    maximum_completion: this.maximum_completion,
                    date_from: this.date_from,
                    date_to: this.date_to
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }
        },

        clearSearch() {
            this.user_name = null;
            this.fetchInitial();
        }
    }
};
</script>

<style scoped>
.table-danger {
    background-color: #f8d7da !important;
    color: #721c24 !important;
}
</style>
